import React, { useCallback, useMemo } from 'react';
import { VideoPlayerStateObject } from '../types';

/**
 * Custom hook to handle child rendering logic for VideoPlayer
 * Passes videoPlayerState to all child components
 */
export const useVideoPlayerChildren = (children: React.ReactNode, videoPlayerState: VideoPlayerStateObject) => {
  // Memoize the children mapping function to prevent unnecessary re-renders
  const childrenMap = useMemo(() => {
    if (!children) return null;

    return React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        // Pass videoPlayerState to all child components
        return React.cloneElement(child, {
          videoPlayerState: videoPlayerState,
        } as React.JSX.IntrinsicAttributes);
      }
      return child;
    });
  }, [children, videoPlayerState]);

  // Return a stable callback that returns the memoized children
  return useCallback(() => childrenMap, [childrenMap]);
};
